import React from "react";
import './HighlightModal.css';
import { Modal } from "react-bootstrap";

const HighlightModal = ({ show, onhide, imageSrc }) => {
  return (
    <Modal
      show={show}
      onHide={onhide}
      size="lg"
      centered
      keyboard
      backdrop
    >
      <Modal.Body style={{ padding: 0 }}>
        <img src={imageSrc} alt={`Memory ${imageSrc}`} style={{ width: '100%'}} />
      </Modal.Body>
    </Modal>
  );
}

export default HighlightModal;